import { DEFAULT_OVERRIDES, DEFAULT_STATUS_MESSAGES } from './defaults.js';
import { extractErrorFields } from './error-fields.js';
export function resolveApiError(error, overrides = {}) {
    const fields = extractErrorFields(error);
    const mergedOverrides = { ...DEFAULT_OVERRIDES, ...overrides };
    const userMessage = resolveUserMessage(fields, mergedOverrides);
    const notification = resolveNotification(fields, userMessage, mergedOverrides);
    return {
        ...fields,
        userMessage,
        notification,
    };
}
function resolveUserMessage(fields, overrides) {
    if (fields.code && overrides.codeMessages?.[fields.code]) {
        return overrides.codeMessages[fields.code];
    }
    if (fields.status !== undefined) {
        const overrideMessage = overrides.statusMessages?.[fields.status];
        if (overrideMessage) {
            return overrideMessage;
        }
        const defaultStatusMessage = DEFAULT_STATUS_MESSAGES[fields.status];
        if (defaultStatusMessage) {
            return defaultStatusMessage;
        }
    }
    if (fields.category === 'network') {
        return overrides.networkError ?? DEFAULT_OVERRIDES.networkError;
    }
    if (fields.message.length < 100) {
        return fields.message;
    }
    return overrides.unknownError ?? DEFAULT_OVERRIDES.unknownError;
}
function resolveNotification(fields, userMessage, overrides) {
    if (fields.category === 'auth') {
        return {
            kind: 'auth',
            title: 'Authentication error',
            message: mergedAuthMessage(overrides),
        };
    }
    if (fields.category === 'server') {
        return {
            kind: 'server',
            title: overrides.serverErrorTitle ?? DEFAULT_OVERRIDES.serverErrorTitle,
            message: overrides.serverErrorMessage ?? DEFAULT_OVERRIDES.serverErrorMessage,
        };
    }
    if (fields.category === 'client') {
        const message = userMessage.length < 100
            ? userMessage
            : overrides.statusMessages?.[fields.status ?? 0] ?? null;
        if (!message) {
            return null;
        }
        return {
            kind: 'client',
            title: overrides.clientErrorTitle ?? DEFAULT_OVERRIDES.clientErrorTitle,
            message,
        };
    }
    return null;
}
function mergedAuthMessage(overrides) {
    return overrides.authEventMessage ?? DEFAULT_OVERRIDES.authEventMessage;
}
